import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import * as news from './news';
import * as notice from './notice';
import * as contacts from './contacts';
import * as general from './general';
import * as services from './services';
import * as images from './images';
import * as partners from './partners';
import * as articles from './articles';
import * as team from './team';
import * as text from './text';
import * as login from './login';
import * as interviews from './interviews';
import * as config from './config';

export default combineReducers({
  routing,
  form,
  [news.REDUCER_NAME]: news.reducer,
  [notice.REDUCER_NAME]: notice.reducer,
  [services.REDUCER_NAME]: services.reducer,
  [contacts.REDUCER_NAME]: contacts.reducer,
  [general.REDUCER_NAME]: general.reducer,
  [images.REDUCER_NAME]: images.reducer,
  [partners.REDUCER_NAME]: partners.reducer,
  [articles.REDUCER_NAME]: articles.reducer,
  [team.REDUCER_NAME]: team.reducer,
  [text.REDUCER_NAME]: text.reducer,
  [login.REDUCER_NAME]: login.reducer,
  [interviews.REDUCER_NAME]: interviews.reducer,
  [config.REDUCER_NAME]: config.reducer,
});



// WEBPACK FOOTER //
// ./src/redux/modules/reducer.js